"use strict";
exports.__esModule = true;
exports.getHeadlineResponsiveClassName = void 0;
// (C) 2021 GoodData Corporation
var calculateCustomHeight_1 = require("./calculateCustomHeight");
var RESPONSIVE_SMALL = "gd-small";
var RESPONSIVE_MEDIUM = "gd-medium";
var RESPONSIVE_LARGE = "gd-large";
var RESPONSIVE_SHORTENED_LABEL = "gd-shortened-label";
/**
 * @internal
 * Provides responsive class for headline/kpi component based on its width and state of secondary item
 */
exports.getHeadlineResponsiveClassName = function (width, isShortened) {
    if (!width) {
        return "";
    }
    if (width < calculateCustomHeight_1.SMALL_COMPARE_SECTION_THRESHOLD) {
        return isShortened ? RESPONSIVE_SHORTENED_LABEL : RESPONSIVE_SMALL;
    }
    return isShortened ? RESPONSIVE_MEDIUM : RESPONSIVE_LARGE;
};
//# sourceMappingURL=headlineResponsiveClassName.js.map